// extracted by css-extract-rspack-plugin
export default {"PageLayout":"paginated-archive-view-module__PageLayout__GmSwp","Box":"paginated-archive-view-module__Box__OMe6M","ArchiveList":"paginated-archive-view-module__ArchiveList__OsOn5"};